
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { HeadersPath } from '../../Utils/ScreenPath';
import CustomDropdown from '../../Common/CustomDropdown';
import { FileQuestion, Lock, Printer } from 'lucide-react';
import { Button } from '../../Common/Button';
import Exam from '../../assets/images/Exam.png';
import bookmark from '../../assets/images/bookmark.png';
import clipboard from '../../assets/images/clipboard.png';
import task from '../../assets/images/task.png'
import book from '../../assets/images/book.png';
import clipboardTick from "../../assets/images/clipboardTick.png"
import { ErrorToast } from '../../Common/Toast';
import { Api } from '../../Service/api';
import moment from 'moment';
import SubjectPurchase from '../../Common/SubjectPurchase';
import { useNavigate, useLocation } from 'react-router-dom';
import { path } from '../../Utils/ScreenPath';

const SamplePaper = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const boardDataList = useSelector((state) => state?.Board?.BoardData || {});
    const mediumDataList = useSelector((state) => state?.Medium?.MediumData || {});

    const [selectedDrpData, setSelectedDrpData] = useState({
        board: "",
        medium: "",
        standard: "",
        semester: "",
        subject: "",
    });

    const [boardData, setBoardData] = useState([]);
    const [mediumData, setMediumData] = useState([]);
    const [standardData, setStandardData] = useState([]);
    const [semesterData, setSemesterData] = useState([]);
    const [subjectData, setSubjectData] = useState([]);
    const [samplePapers, setSamplePapers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isPurchaseModelOpen, setIsPurchaseModelOpen] = useState(false);
    const [chapterResponse, setChapterResponse] = useState(null); // Store full API response including isLocked
    const [isChapterLoading, setIsChapterLoading] = useState(false);

    const handleDropDownChange = (name, value) => {
        setSelectedDrpData({ ...selectedDrpData, [name]: value });
        if (name === "board") {
            setSelectedDrpData((prev) => ({
                ...prev,
                medium: "",
                standard: "",
                semester: "",
                subject: "",
                [name]: value,
            }));
            setMediumData([]);
            setStandardData([]);
            setSemesterData([]);
            setSubjectData([]);
            setSamplePapers([]);
            setChapterResponse(null);
        }


        if (name === "medium") {
            let payload = {
                ...selectedDrpData,
                standard: "",
                semester: "",
                subject: "",
                [name]: value,
            };
            setSelectedDrpData(payload);
            setStandardData([]);
            setSemesterData([]);
            setSubjectData([]);
            setSamplePapers([]);
            setChapterResponse(null);
        }


        if (name === "standard") {
            let payload = {
                ...selectedDrpData,
                semester: "",
                subject: "",
                [name]: value,
            };
            setSelectedDrpData(payload);
            setSemesterData([]);
            setSubjectData([]);
            setSamplePapers([]);
            setChapterResponse(null);
        }


        if (name === "semester") {
            let payload = {
                ...selectedDrpData,
                subject: "",
                [name]: value,
            };
            setSelectedDrpData(payload);
            setSubjectData([]);
            setSamplePapers([]);
            setChapterResponse(null);
        }


        if (name === "subject") {
            let payload = {
                ...selectedDrpData,
                [name]: value,
            };
            setSelectedDrpData(payload);
            setChapterResponse(null);
        }
    };

    const handleGetBoard = async () => {
        dispatch(ACTIONS.startLoading());
        try {
            let params = {
                isOthers: true,
            };
            dispatch(ACTIONS.getBoardData(params));
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading());
        }
    };

    const handleGetMedium = async () => {
        dispatch(ACTIONS.startLoading());
        try {
            let params = {
                board: selectedDrpData?.board?.id,
                isOthers: true,
            };
            dispatch(ACTIONS.getMediumData(params));
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading());
        }
    };

    const handleGetStandard = async () => {
        dispatch(ACTIONS.startLoading());
        try {
            let params = `?medium=${selectedDrpData?.medium?.id}`;
            const { data } = await Api.GetSampleStandard(params);
            const res = JSON.parse(data);
            if (res?.status === 200) {
                setStandardData(res);
            } else {
                ErrorToast(res?.message);
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading());
        }
    };

    const handleGetSemester = async () => {
        dispatch(ACTIONS.startLoading());
        try {
            let params = `?standard=${selectedDrpData?.standard?.id}`;
            const { data } = await Api.GetSampleSemester(params);
            const res = JSON.parse(data);
            if (res?.status === 200) {
                setSemesterData(res);
            } else {
                ErrorToast(res?.message);
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading());
        }
    };

    const handleGetSubject = async () => {
        dispatch(ACTIONS.startLoading());
        try {
            let params = `?standard=${selectedDrpData?.standard?.id}&semester=${selectedDrpData?.semester?.id}`;
            const { data } = await Api.GetSampleSubject(params);
            const res = JSON.parse(data);
            if (res?.status === 200) {
                setSubjectData(res);
            } else {
                ErrorToast(res?.message);
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading());
        }
    };

    const handleGetSamplePapers = async () => {
        setIsLoading(true);
        try {
            let params = `?board=${selectedDrpData?.board?.id}&medium=${selectedDrpData?.medium?.id}&standard=${selectedDrpData?.standard?.id}&semester=${selectedDrpData?.semester?.id}&subject=${selectedDrpData?.subject?.id}&limit=100&offset=1`;
            const { data } = await Api.GetSamplePapers(params);
            const res = JSON.parse(data);
            if (res?.status === 200) {
                setSamplePapers(res?.data);
            } else {
                setSamplePapers([]);
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            setIsLoading(false);
        }
    };



    const parseSectionsInfo = (sectionsInfo) => {
        try {
            const parsed = typeof JSON.parse(sectionsInfo) === 'string'
                ? JSON.parse(JSON.parse(sectionsInfo))
                : JSON.parse(sectionsInfo);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    };

    const handleGetChapter = async () => {
        setIsChapterLoading(true);
        try {
            const params = {
                standard: selectedDrpData?.standard?.id,
                semester: selectedDrpData?.semester?.id,
                subject: selectedDrpData?.subject?.id,
            };
            const { data } = await Api.GetChapter(params);
            const res = JSON.parse(data);
            if (res?.status === 200) {
                setChapterResponse(res);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsChapterLoading(false);
        }
    };



    const handlePaperClick = (item) => {
        if (isChapterLoading) return;

        // Check isLocked from API root level
        const isLockedValue = chapterResponse?.isLocked;
        const isLocked = isLockedValue === true || isLockedValue === "true" || isLockedValue === 1 || isLockedValue === "1";

        if (isLocked) {
            setIsPurchaseModelOpen(true);
            return;
        }



        // Prepare data for GenerateExamPaper/EditPaper flow
        // Older sample papers have finalsections_info = null; fall back to sections_info
        let parsedSections = parseSectionsInfo(item?.paperInfo?.finalsections_info);
        if (parsedSections.length === 0) {
            parsedSections = parseSectionsInfo(item?.paperInfo?.sections_info);
        }

        const data = {
            institute_logo: '',
            school_name: '',
            template_name: '',
            exam_name: '',
            chapter_name: '',
            exam_time: '',
            exam_marks: item?.paperInfo?.exam_marks,
            medium: selectedDrpData?.medium?.id,
            exam_date: moment(new Date()).format('DD/MM/YYYY'),
            paper_type: 'manually',
            genrate_type: item?.paperInfo?.genrate_type,
            standard_id: selectedDrpData?.standard?.id,
            standard_name: selectedDrpData?.standard?.name,
            subject_id: selectedDrpData?.subject?.id,
            subject_name: selectedDrpData?.subject?.subject,
            semester_id: selectedDrpData?.semester?.id,
            semester_name: selectedDrpData?.semester?.semester,
            sections_info: parsedSections,
        };

        dispatch(ACTIONS.getSelectedData(data));
        navigate(path.ManuallyGenerate + "/samplePaper");
    };

    useEffect(() => {
        if (boardDataList?.status === 200) {
            setBoardData(boardDataList);
        }
    }, [boardDataList]);

    useEffect(() => {
        setMediumData(mediumDataList);
    }, [mediumDataList]);

    useEffect(() => {
        if (selectedDrpData?.board) {
            handleGetMedium();
        }
    }, [selectedDrpData?.board]);

    useEffect(() => {
        if (selectedDrpData?.medium) {
            handleGetStandard();
        }
    }, [selectedDrpData?.medium]);

    useEffect(() => {
        if (selectedDrpData?.standard) {
            handleGetSemester();
        }
    }, [selectedDrpData?.standard]);

    useEffect(() => {
        if (selectedDrpData?.semester) {
            handleGetSubject();
        }
    }, [selectedDrpData?.semester]);

    useEffect(() => {
        if (selectedDrpData?.subject) {
            handleGetSamplePapers();
            handleGetChapter(); // Fetch chapter data to check lock status
        }
    }, [selectedDrpData?.subject]);

    useEffect(() => {
        dispatch(ACTIONS.getHeaderPath(HeadersPath.SamplePaper));
        handleGetBoard();
    }, []);

    const onPaymentSuccess = () => {
        // handle payment success if needed
    };

    return (
        <div>
            <div
                style={{ color: "#DC0000", margin: "7px 0" }}
                className="lg:text-base text-sm "
            >
                સૂચના : તમે અમારાં સેમ્પલ પેપરનો ઉપયોગ કરીને પેપર બનાવી શકો છો અને તમારી જરૂર મુજબ તેમાં ફેરફાર કરીને તમારું પોતાનું પેપર તૈયાર કરી શકો છો. તેનો કોઈ અલગ થી ચાર્જ લેવામાં આવેલ નથી. વધારે માહિતી માટે 9712444548 પર સંપર્ક કરો.
            </div>

            <div className="flex flex-col gap-2 lg:gap-4 mb-3">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 lg:gap-4">
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Board"
                            data={boardData?.data || []}
                            textKey="board_name"
                            onSelect={(e) => handleDropDownChange("board", e)}
                            defaultValue={selectedDrpData?.board?.board_name || "Select Board"}
                            icon={<img src={Exam} alt="Exam Icon" className="w-5 h-5" />}
                        />
                    </div>
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Medium"
                            data={selectedDrpData?.board ? mediumData?.data : []}
                            textKey="name"
                            onSelect={(e) => handleDropDownChange("medium", e)}
                            defaultValue={selectedDrpData?.medium?.name || "Select Medium"}
                            icon={<img src={bookmark} alt="Medium Icon" className="w-5 h-5" />}
                        />
                    </div>
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Standard"
                            data={selectedDrpData?.medium ? standardData?.data : []}
                            textKey="name"
                            onSelect={(e) => handleDropDownChange("standard", e)}
                            defaultValue={selectedDrpData?.standard?.name || "Select Standard"}
                            icon={<img src={clipboard} alt="Standard Icon" className="w-5 h-5" />}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 lg:gap-4">
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Semester"
                            data={selectedDrpData?.standard ? semesterData?.data : []}
                            rows={true}
                            textKey="semester"
                            onSelect={(e) => handleDropDownChange("semester", e)}
                            defaultValue={selectedDrpData?.semester?.semester || "Select Semester"}
                            icon={<img src={task} alt="Semester Icon" className="w-5 h-5" />}
                        />
                    </div>
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Subject"
                            data={selectedDrpData?.semester ? subjectData?.data : []}
                            textKey="subject"
                            onSelect={(e) => handleDropDownChange("subject", e)}
                            defaultValue={selectedDrpData?.subject?.subject || "Select Subject"}
                            icon={<img src={book} alt="Subject Icon" className="w-5 h-5" />}
                        />
                    </div>
                </div>
            </div>

            {selectedDrpData?.subject && (
                <div className="mt-6">
                    <h2 className="text-xl font-semibold mb-4">Available Sample Papers</h2>
                    {isLoading ? (
                        <div className="flex justify-center items-center py-10">
                            <div className="loader" style={{ '--_g': 'no-repeat radial-gradient(circle closest-side, #3b82f6 90%, #0000)' }}></div>
                        </div>
                    ) : samplePapers.length > 0 ? (
                        <div className="flex flex-col gap-3">
                            {samplePapers.map((item, index) => (
                                <div key={index}
                                    className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-all flex justify-between items-center"
                                    onClick={() => handlePaperClick(item)}
                                >
                                    <div className="flex flex-col">
                                        <h3 className="font-semibold text-gray-800 text-base">
                                            Sample Paper {index + 1}
                                            <span className="text-gray-500 font-normal text-sm ml-1">
                                                ({item?.paperInfo?.genrate_type})
                                            </span>
                                        </h3>
                                        {item?.paperInfo?.chapter_name && (
                                            <div className="text-sm text-gray-500 mt-1">
                                                <span className="font-medium">Ch:</span> {item?.paperInfo?.chapter_name}
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex items-center gap-4">
                                        <span className="font-semibold text-sm text-gray-700">
                                            Marks {item?.paperInfo?.exam_marks}
                                        </span>
                                        {(() => {
                                            const isLockedValue = chapterResponse?.isLocked;
                                            const showLock = isLockedValue === true || isLockedValue === "true" || isLockedValue === 1 || isLockedValue === "1";
                                            return showLock ? (
                                                <Lock className="w-5 h-5 text-gray-700" />
                                            ) : (
                                                <div className="w-5 h-5"></div>
                                            );
                                        })()}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-10 text-gray-500">
                            No sample papers found for the selected criteria.
                        </div>
                    )}
                </div>
            )}

            <SubjectPurchase
                isModelOpen={isPurchaseModelOpen}
                setIsPurchaseModelOpen={setIsPurchaseModelOpen}
                selectedDrpData={selectedDrpData}
                onPaymentSuccess={onPaymentSuccess}
            />
        </div>
    )
}

export default SamplePaper
